import { createSelector } from '@ngrx/store';
import { PermissionStateInterface, selectAll } from './permission.state';
import { getPermissionState } from '../setting.selectors';

export const getAllPermissions = createSelector(
  getPermissionState,
  (state: PermissionStateInterface) => selectAll(state)
);
